import React from 'react';

export default function Pencil(props) {
  const styles = props.height ? { height: props.height } : null;
  return (
    <svg
      height="48.438"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 47.938 48.438"
      width="47.938"
      xmlns="http://www.w3.org/2000/svg"
      style={styles}
      {...props}>
      <path
        d="m46.3 9.641c-.032.033-.073.046-.108.073-.028.038-.043.082-.077.117l-3.061 3.093s0 .001-.001.001v.001l-30.231 30.548c-.001.001-.002.001-.002.002l-.004.004c-.094.095-.204.169-.324.219l-11.097 4.653c-.123.052-.254.077-.382.077-.26 0-.515-.103-.706-.296-.286-.288-.372-.722-.217-1.099l4.6-11.211c.001 0 .001-.001.001-.002l.002-.005c.024-.057.067-.097.099-.148.038-.06.065-.126.118-.18l.005-.005 30.231-30.551 3.061-3.094c.033-.034.076-.048.112-.075.027-.037.041-.08.074-.113 2.18-2.203 5.727-2.203 7.907 0 1.056 1.067 1.638 2.486 1.637 3.996 0 1.51-.581 2.929-1.637 3.995zm-43.441 35.912 7.489-3.14-4.382-4.43zm9.251-4.213 28.826-29.129-5.084-5.139-28.824 29.13zm32.778-38.263c-1.402-1.416-3.681-1.416-5.083 0-.033.033-.076.047-.112.075-.027.036-.041.079-.074.112l-2.355 2.381 5.084 5.139 2.355-2.38c.032-.032.073-.046.108-.073.029-.038.043-.082.077-.117.679-.685 1.052-1.597 1.052-2.568s-.373-1.883-1.052-2.569z"
        fill="#1b1b1b"
        fillRule="evenodd"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/pencil.js